package de.ohhhmhhh.frontend.admin.ui.screens.team

data class TeamEditPageState(
    val items: List<TeamEditItem> = listOf()
)

